import client from './client';
import type { ApiResponse, NodeResponse, CreateNodeRequest, UpdateNodeRequest } from './types';

export async function getNodes(): Promise<ApiResponse<NodeResponse[]>> {
  return client.get('/nodes');
}

export async function getNode(id: string): Promise<ApiResponse<NodeResponse>> {
  return client.get(`/nodes/${id}`);
}

export async function createNode(data: CreateNodeRequest): Promise<ApiResponse<NodeResponse>> {
  return client.post('/nodes', data);
}

export async function updateNode(id: string, data: UpdateNodeRequest): Promise<ApiResponse<NodeResponse>> {
  return client.put(`/nodes/${id}`, data);
}

export async function deleteNode(id: string): Promise<ApiResponse<null>> {
  return client.delete(`/nodes/${id}`);
}
